import { render, staticRenderFns } from "./LinkStudentModal.vue?vue&type=template&id=e3eb4544&"
import script from "./LinkStudentModal.vue?vue&type=script&lang=js&"
export * from "./LinkStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports